import script from "./FlightPlusHotelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FlightPlusHotelModal.vue?vue&type=script&setup=true&lang=js"

import "./FlightPlusHotelModal.vue?vue&type=style&index=0&id=5776b080&lang=scss"

const __exports__ = script;

export default __exports__